<template>
    <v-container>
        <v-card>
            <v-card-title class="text-h6">
                لا تملك الصلاحية الكافية لمعاينة الصفحة
            </v-card-title>
            <v-card-text class="text-subtitle-1">
                سيتم توجيهك إلى الصفحة الرئيسية في {{ time }} ثواني
                <br />
                <router-link to="/">
                    في حال لم يتم توجيهك قم بالنقر هنا للانتقال
                </router-link>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
	name: "NonAuthorized",
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			time: 5,
			interval: null,
		};
	},
	watch: {
		time(newVal) {
			if (newVal <= 0) {
				clearInterval(this.interval);
				this.$router.push("/");
			}
		},
	},
	mounted() {
		this.interval = setInterval(() => {
			this.time--;
			console.log(this.time);
		}, 1000);
	},
	beforeDestroy() {
		clearInterval(this.interval);
	}
};
</script>
